import {isDefault} from 'core/Budget';
import {isEmpty as isEmptyHistory} from 'core/History';
import {isEmpty as isEmptyKeyboard} from 'ui/keyboard';
import {useBudgetStore} from 'store/Budget';
import {useHistoryStore} from 'store/History';
import {useKeyboard} from 'store/UserInput';

export function usePristineDetector(): boolean {
  const budget = useBudgetStore();
  const history = useHistoryStore();
  const keyboard = useKeyboard();

  return isEmptyHistory(history) && isDefault(budget) && isEmptyKeyboard(keyboard);
}
